@import (reference) '../../../../constants/spacing.module.less';

@button-background: var(--green-0D6E3F);

.header {
  justify-content: space-between;
  align-items: center;
  padding: @space-16 @space-0 @space-16 @space-0;
}

.title {
  font-size: 24px;
  font-weight: 500;
  margin: @space-0 @space-16 @space-0 @space-0;
}

.buttons-container {
  gap: @space-8;
}

.actions-button {
  height: 32px;
  display: flex;
  align-items: center;
  background-color: var(--green-D8FFEB);
  padding-left: @space-12;
  padding-right: @space-4;
  border-radius: 4px;
  border: 1px solid @button-background;
  cursor: pointer;
}

.actions-text {
  font-size: 14px;
  font-weight: 500;
  color: @button-background;
  cursor: pointer;
}

.menu-dropdown {
  max-width: 100px;
}
